import React from 'react';
import { FormField } from '../../../../components/FormField';

interface PromotionAmenitiesProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PromotionAmenities: React.FC<PromotionAmenitiesProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <FormField label="Proximité des commodités">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <h4 className="font-medium text-gray-700 dark:text-gray-300">Transports</h4>
          {[
            { name: 'hasBusNearby', dbName: 'bus_nearby', label: 'Bus' },
            { name: 'hasMetroNearby', dbName: 'metro_nearby', label: 'Métro' },
            { name: 'hasTramNearby', dbName: 'tram_nearby', label: 'Tram' },
            { name: 'hasTrainNearby', dbName: 'train_nearby', label: 'Train' },
          ].map(({ name, dbName, label }) => (
            <label key={name} className="flex items-center gap-2">
              <input
                type="checkbox"
                name={name}
                checked={property?.[dbName] ?? formData[name] ?? false}
                onChange={handleInputChange}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
        <div className="space-y-2">
          <h4 className="font-medium text-gray-700 dark:text-gray-300">Services</h4>
          {[
            { name: 'hasShopsNearby', dbName: 'shops_nearby', label: 'Commerces' },
            { name: 'hasSchoolsNearby', dbName: 'schools_nearby', label: 'Écoles' },
            { name: 'hasUniversityNearby', dbName: 'universities_nearby', label: 'Universités' },
            { name: 'hasHospitalNearby', dbName: 'hospitals_nearby', label: 'Hôpitaux' },
            { name: 'hasAdministrationNearby', dbName: 'administrations_nearby', label: 'Administrations' },
          ].map(({ name, dbName, label }) => (
            <label key={name} className="flex items-center gap-2">
              <input
                type="checkbox"
                name={name}
                checked={property?.[dbName] ?? formData[name] ?? false}
                onChange={handleInputChange}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </div>
    </FormField>
  );
};